/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

type Props = {
  eyebrow?: string | null;
};

function Eyebrow({ eyebrow }: Props) {
  const styles: Record<string, Interpolation<Theme>> = {
    eyebrow: () => css`
      text-transform: uppercase;
      margin-bottom: var(--cds-spacing-300);
    `,
  };

  return (
    <>
      {eyebrow && (
        <Typography2 component="p" variant="bodyPrimary" css={styles.eyebrow} color="inherit">
          {eyebrow}
        </Typography2>
      )}
    </>
  );
}

export default Eyebrow;
